export default "__VITE_ASSET__49695b97__"